import {Component, OnInit} from '@angular/core';
import {AppContainerOptions, AppContainerService, IAppContainerFrame, UserMenuItemsEnum} from '@mydocma/app-container';
import {environment} from '../../environments/environment';
import package_json from '../../../package.json';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [],
})
export class MainComponent implements OnInit, IAppContainerFrame {

  public version: string = package_json.version;

  constructor(
    public options: AppContainerOptions,
    private appContainerService: AppContainerService,
  ) {
    this.appContainerService.notifyChanges((appcontainer) => {
      appcontainer.appIcon.name = environment.appName;
      appcontainer.appIcon.color = environment.appIconColor;
      appcontainer.header.userMenuItems.version = this.version;
      appcontainer.header.userMenuItems.items.find(value => {
        if (value.id === UserMenuItemsEnum.userSettings) {
          value.hidden = true;
          return;
        }
      });

    });
  }

  acOnRegister(appContainer: AppContainerOptions) {
    // buttons.push(new LinkSideNavButton({id: 'pix3', text: 'Help', url: '/pix/help'}));
    // appContainer.sideNavBar.buttons = buttons;
  }

  acOnUnregister(appContainer: AppContainerOptions) {
    appContainer.sideNavBar.buttons = [];
    appContainer.topActionsBar.buttons = [];
  }

  ngOnInit() {
  }

}
